/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

// import report
import ListSettlement from '../views/settlement-setting/ListSettlement.vue';

import { setBreadcrumb } from './index';

const settlementSettingRoute = {
  path: '/settlement-setting',
  children: [
    {
      path: '',
      meta: {
        title: 'BNI QRIS - Settlement Setting',
        appBarTitle: 'Settlement Setting',
        breadcrumbs: () => [
          setBreadcrumb('Settlement Setting', '/settlement-setting', true),
          setBreadcrumb('List Settlement Setting', '/settlement-setting'),
        ],
      },
      component: ListSettlement,
      name: 'ListSettlement',
    },
  ],
  meta: {
    title: 'BNI QRIS - Settlement Setting',
    appBarTitle: 'Settlement Setting',
  },
  component: Parent,
};
export default settlementSettingRoute;
